import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {ServiceRattachementListPage} from './ServiceRattachementListPage'
import {ServiceRattachementPage} from './ServiceRattachementPage'

const ServiceRattachementWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Paramètres',
                    path: '#',
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
              >
                Service de rattachement
              </PageTitle>
              <ServiceRattachementListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Service de rattachement', path: '/service-rattachement', isSeparator: false, isActive: true},
                ]}
              >
                Création
              </PageTitle>
              <ServiceRattachementPage />
            </>
          }
        />
        <Route
          path='/:serviceRattachementId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Service de rattachement', path: '/service-rattachement', isSeparator: false, isActive: true},
                ]}
              >
                Modification
              </PageTitle>
              <ServiceRattachementPage />
            </>
          }
        />
        <Route index element={<Navigate to='/service-rattachement/liste' />} />
      </Routes>
    </>
  )
}

export {ServiceRattachementWrapper}
